
import React from 'react';
import ConsultationForm from './components/ConsultationForm';
import ConsultationInfo from './components/ConsultationInfo';

const ConsultationPage: React.FC = () => {
  return (
    <div className="min-h-screen pt-20">
      <div className="bg-teal-500 text-white py-16">
        <div className="container mx-auto px-6 text-center">
          <h1 className="text-4xl md:text-5xl font-bold mb-6">
            Schedule Your Free Consultation
          </h1>
          <p className="text-xl text-teal-100 max-w-3xl mx-auto">
            Take the first step towards business ownership with a personalized consultation from our certified business brokers.
          </p>
        </div>
      </div>

      <div className="py-16">
        <div className="container mx-auto px-6">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12">
            <ConsultationInfo />
            <ConsultationForm />
          </div>
        </div>
      </div>
    </div>
  );
};

export default ConsultationPage;
